export const fmtMoney = (n) =>
  new Intl.NumberFormat("uk-UA", { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(Number(n || 0)) + " грн";

export const CUR_SYM = { UAH: "₴", USD: "$", EUR: "€" };

export const fmtCur = (n, cur = "UAH") =>
  new Intl.NumberFormat("uk-UA", { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(Number(n || 0)) + " " + (CUR_SYM[cur] || "₴");

export const sumByCurrency = (rows) => {
  const acc = {};
  (rows || []).forEach((x) => { const c = x.currency || "UAH"; acc[c] = (acc[c] || 0) + Number(x.price || 0) * Number(x.qty || 0); });
  return acc;
};

export const fmtTotals = (byCur) => {
  const entries = Object.entries(byCur || {}).filter(([, v]) => v);
  if (!entries.length) return fmtCur(0);
  return entries.map(([c, v]) => fmtCur(v, c)).join(" · ");
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("uk-UA", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch { return iso; }
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("uk-UA", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
};

export const ORDER_STATUSES = [
  { key: "new", label: "Новий", color: "#32ADE6" },
  { key: "in_progress", label: "В роботі", color: "#FFCC00" },
  { key: "ready", label: "Готово", color: "#34C759" },
  { key: "delivered", label: "Видано", color: "#8E8E93" },
];

export const statusMeta = (key) => ORDER_STATUSES.find((s) => s.key === key) || { label: key, color: "#8E8E93" };

export const ROLE_LABELS = {
  admin: "Адміністратор",
  manager: "Менеджер / приймальник",
  master: "Майстер / механік",
  storekeeper: "Комірник",
  accountant: "Бухгалтер",
};
